export { default as NewSalesRoute } from './NewSalesRoute';
